import AwarePartner from './AwarePartner';

export default AwarePartner;
